import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 翻訳リソースのインポート
import translationJA from './locales/ja/translation.json';
import translationEN from './locales/en/translation.json';
import translationTH from './locales/th/translation.json';

// 翻訳リソースの設定
const resources = {
  ja: {
    translation: translationJA,
  },
  en: {
    translation: translationEN,
  },
  th: {
    translation: translationTH,
  },
};

// i18next設定
i18n
  .use(LanguageDetector) // ブラウザの言語設定を自動検出
  .use(initReactI18next) // React統合を有効化
  .init({
    resources,
    fallbackLng: 'ja', // デフォルト言語
    debug: process.env.NODE_ENV === 'development', // 開発時のみデバッグ有効

    interpolation: {
      escapeValue: false, // ReactはXSS保護が組み込まれているため無効化
    },

    // 言語検出設定
    detection: {
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0,
      checkWhitelist: true,
    },

    // 対応言語のホワイトリスト
    supportedLngs: ['ja', 'en', 'th'],
    nonExplicitSupportedLngs: true,
  });

export default i18n;
